module.exports = __webpack_public_path__ + "static/media/choithramsPepsiProductOne.979225c0.jpg";